import SharedPinScreen from './SharedPin';
const routes = {
    'w/:wallet_id': {
        path: '/w/:wallet_id',
        title: 'Pin',
        component: SharedPinScreen,
        auth: false,
    },
};
export default routes;
